import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import React from 'react';

const ColumnContainerView = () => {
    return (
        <NodeViewWrapper className="doc-column-container" style={{ display: 'flex', width: '100%', gap: '16px' }}>
            <NodeViewContent className="doc-column-container-inner" style={{ display: 'flex', width: '100%', gap: '16px' }} />
        </NodeViewWrapper>
    );
};

export const ColumnContainerExtension = Node.create({
    name: 'columnContainer',
    group: 'block',
    content: 'column+',

    parseHTML() {
        return [{ tag: 'div.doc-column-container' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({ class: 'doc-column-container' }, HTMLAttributes), 0];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ColumnContainerView);
    },
});

// Integración main→dev, epic D2: el arrastre de redimensión de columna emitía un
// `window` CustomEvent (`doc-column-resize-start`) que NINGÚN listener consumía — ni en `main`
// ni en `dev` — y los CustomEvents están prohibidos por política. Se elimina; las columnas
// quedan con ancho fijo (`node.attrs.width`, por defecto 50%). La redimensión interactiva puede
// volver como slice propio si se pide, sin bus de eventos.
const ColumnView = ({ node }) => {
    return (
        <NodeViewWrapper
            className="doc-column"
            style={{ width: node.attrs.width || '50%', paddingRight: '4px' }}
        >
            <NodeViewContent />
        </NodeViewWrapper>
    );
};

export const ColumnExtension = Node.create({
    name: 'column',
    content: 'block+',
    
    addAttributes() {
        return {
            width: { default: '50%' }
        };
    },

    parseHTML() {
        return [{ 
            tag: 'div.doc-column',
            getAttrs: node => ({ width: node.style.width })
        }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({ class: 'doc-column' }, HTMLAttributes), 0];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ColumnView);
    },
});
